import { useTranslation } from 'react-i18next'

export function VoxnelaMark({ animated = false }: { animated?: boolean }) {
  return (
    <svg
      className={`brand-mark voxnela-brand-mark${animated ? ' brand-mark-animated' : ''}`}
      viewBox="120 152 764 720"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <g className="voxnela-brand-bars">
        <rect x="140" y="457" width="60" height="110" rx="30" />
        <rect x="240" y="382" width="60" height="260" rx="30" />
        <rect x="340" y="277" width="60" height="470" rx="30" />
        <rect x="440" y="172" width="60" height="680" rx="30" />
      </g>
      <path className="voxnela-brand-play" d="M570 277v470l294-235z" />
    </svg>
  )
}

export function VoxnelaLoadingState({
  className = '',
  compact = false,
  label,
}: {
  className?: string
  compact?: boolean
  label?: string
}) {
  const { t } = useTranslation()

  return (
    <span
      className={`voxnela-loading-state${compact ? ' compact' : ''}${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="generation-logo" aria-hidden="true">
        <VoxnelaMark animated />
      </span>
      <span>{label ?? t('common.loading')}</span>
    </span>
  )
}

export function VoxnelaLoader({
  label,
}: {
  label?: string
}) {
  const { t } = useTranslation()

  return (
    <div className="voxnela-loader" role="status" aria-live="polite">
      <span className="generation-logo" aria-hidden="true">
        <VoxnelaMark animated />
      </span>
      <span>{label ?? t('common.loading')}</span>
    </div>
  )
}
